<template>
  <div>
    <div style="text-align: right;padding-bottom: 9px;" id="rccx">
      <b>订单名称：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.oname"
                placeholder="请输入"/>
      <b>涉及商品：</b>
      <el-select v-model="queryParams.pid" placeholder="请选择" style="width: 110px;">
        <el-option
            v-for="item in spList"
            :key="item.id"
            :label="item.name"
            :value="item.id">
        </el-option>
      </el-select>
      <b>配单人：</b>
      <el-input style="width: 120px;"
                v-model="queryParams.person"
                placeholder="请输入"/>
      <b>配单状态：</b>
      <el-select v-model="queryParams.status" placeholder="请选择"
                 style="width: 110px;">

        <el-option
            label="正在配单"
            value="1"
        ></el-option>
        <el-option
            label="已完成"
            value="2"
        ></el-option>
        <el-option
            label="已退单"
            value="3"
        ></el-option>
      </el-select>
      <el-button type="primary" @click="getList" size="medium" round><i class="el-icon-search"></i>查询</el-button>
      <el-button type="primary" @click="createdata" v-if="checkPrower('bzgys')" size="medium" round><i
          class="el-icon-circle-plus"></i>开始配单
      </el-button>
      <el-button type="warning" @click="cleardata" size="medium" round><i class="el-icon-refresh"></i>重置</el-button>

    </div>

    <el-table v-loading="loading"
              :data="tableData"
              style="width: 100%">
      <el-table-column
          type="index"
          align="center"
          width="70" label="序号">
        <template slot-scope="scope">
          <div v-text="(queryParams.pageNum-1)*queryParams.pageSize+1+scope.$index"></div>
        </template>
      </el-table-column>
      <el-table-column
          label="配单名称"
          prop="oname" align="center">
      </el-table-column>
      <el-table-column
          label="配单时间" width="200"
          prop="ctime" align="center">
      </el-table-column>
      <el-table-column
          label="配单人"
          width="200"
          prop="cuser"
          align="center">
      </el-table-column>
      <el-table-column
          label="备注"
          width="200"
          prop="remark"
          align="center">
      </el-table-column>
      <el-table-column
          label="配单状态" width="150"
          prop="state" align="center">
        <template slot-scope="scope">
          {{ formatstate(scope.row) }}
        </template>
      </el-table-column>

      <el-table-column
          align="center" label="操作" width="300">

        <template slot-scope="scope">
          <el-button
              size="mini"
              type="success"
              v-if="user===scope.row.username && scope.row.state==='1'"
              @click="upMatchState( scope.row,'2')">
            <i class="el-icon-setting"></i>
            出库
          </el-button>
          <el-button
              size="mini"
              type="danger"
              v-if="user===scope.row.username && scope.row.state==='2'"
              @click="upMatchState( scope.row,'3')">
            <i class="el-icon-setting"></i>
            撤回
          </el-button>
          <el-button
              size="mini"
              v-if="user===scope.row.username && scope.row.state>'1'"
              @click="batchExport( scope.row)">
            <i class="el-icon-paperclip"></i>
            导出
          </el-button>
          <el-button
              size="mini"
              v-if="user===scope.row.username  && scope.row.state==='1'"
              @click="handleEdit( scope.row,true)">
            <i class="el-icon-edit"></i>
            修改
          </el-button>
          <el-button
              size="mini"
              type="danger"
              v-if="user===scope.row.username  && scope.row.state==='1'"
              @click="deleterole(scope.$index, scope.row)"><i class="el-icon-delete"></i>删除
          </el-button>
          <el-button
              size="mini"
              v-if="user!==scope.row.username || scope.row.state!=='1'"
              @click="handleEdit(scope.row,false)"><i class="el-icon-view"></i>查看
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <template>
      <div>

        <pagination
            id="companyListpage"
            v-if="total > 0"
            :total="total"
            :center="true"
            :page.sync="queryParams.pageNum"
            :limit.sync="queryParams.pageSize"
            @pagination="getList"
        />
      </div>
    </template>


    <el-dialog :title="dialogTitle" id="dialogTitle" :fullscreen="true" :visible.sync="dialogFormVisible">
      <el-form ref="form" :model="spxxList" id="productfrom" v-if="isupdate">
        <b>产品名称：</b>
        <el-input style="width: 140px;"
                  v-model="spxxList.name"
                  placeholder="请输入产品名称"/>
        <b style="margin-left: 20px">产品参数：</b>
        <el-input style="width: 140px;"
                  v-model="spxxList.cs"
                  placeholder="请输入产品参数"/>
        <el-button type="primary" @click="getspxxList" size="medium" round><i class="el-icon-search">查询</i></el-button>
        <el-button type="warning" @click="clearspxxdata" size="medium" round><i class="el-icon-refresh"></i>重置</el-button>

        <el-form-item style="margin-top: 20px">
          <el-table
              :key="componentKey"
              ref="plxTable"
              :data="spxxList.spxx"
              :max-height="350"
              border
              highlight-current-row
              style="float: left; width: 100%;"
          >
            <el-table-column
                type="index"
                align="center"
                width="70" label="序号">
              <template slot-scope="scope">
                <div v-text="1+scope.$index"></div>
              </template>
            </el-table-column>
            <el-table-column
                label="产品名称"
                prop="name" align="center">
              <template slot-scope="scope">
                {{ scope.row.name ?? '' }}
              </template>
            </el-table-column>
            <el-table-column
                label="参数"
                prop="state" align="center">
              <template slot-scope="scope">
                <div>{{ scope.row.cs ?? '无' }}</div>
              </template>
            </el-table-column>
            <!-- 参数 -->
            <!-- 操作 -->
            <el-table-column
                v-if="isupdate"
                label="操作"
                width="100"
                fixed="right"
            >
              <template slot-scope="scope">
                <el-button
                    type="success"
                    size="mini"
                    @click="insertEvent1(scope.row)"
                >
                  添加
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>

      </el-form>
      <hr style="border: 1.5px solid #ff0000; width: 100%; margin: 20px 0;">
      <el-form ref="form" :model="selectTable" id="scfrom">
        <el-form-item>
          <el-table
              :key="componentKey"
              ref="plxTable"
              :data="selectTable.spxx"
              :max-height="460"
              border
              highlight-current-row
              style="float: left; width: 100%;"
          >
            <!-- 物料 -->
            <el-table-column label="物料" width="270" prop="pid">
              <template #default="{ row, $index }">
                <el-select
                    v-if="isupdate"
                    v-model="row.pid"
                    placeholder="请选择"
                    @change="handlePrnedd({ row, $index })"
                    style="width: 100%;"
                >
                  <el-option
                      v-for="item in spList"
                      :key="item.id"
                      :label="item.name"
                      :value="item.id"
                  />
                </el-select>
                <span v-else>{{ formatproduct(row.pid) }}</span>
              </template>
            </el-table-column>

            <!-- 库存（仅编辑模式显示） -->
            <el-table-column
                v-if="isupdate"
                label="库存"
                prop="yz"
                width="100"
            />

            <!-- 已锁份额（仅编辑模式显示） -->
            <el-table-column
                v-if="isupdate"
                label="已锁份额"
                prop="sd"
                width="120"
            />

            <!-- 数量 -->
            <el-table-column label="数量" prop="num" width="120">
              <template #default="{ row }">
                <el-input
                    v-if="isupdate"
                    v-model="row.num"
                    type="number"
                    :min="1"
                    :disabled="!isupdate"
                />
                <span v-else>{{ row.num }}</span>
              </template>
            </el-table-column>

            <!-- 参数 -->
            <el-table-column label="参数" prop="cs">
              <template #default="{ row }">
                <el-input
                    v-if="isupdate"
                    v-model="row.cs"
                    type="textarea"
                    :maxlength="300"
                    show-word-limit
                    :rows="2"
                    :disabled="!isupdate"
                />
                <span v-else style="white-space: pre-wrap;">{{ row.cs }}</span>
              </template>
            </el-table-column>

            <!-- 操作 -->
            <el-table-column
                v-if="isupdate"
                label="操作"
                width="100"
                fixed="right"
            >
              <template #default="{ $index }">
                <el-button
                    type="danger"
                    size="mini"
                    @click="delEvent($index)"
                >
                  删除
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-form-item>
        <el-form-item label="" label-width="0px" style="" v-if="isupdate">
          <template v-slot="row">
            <el-button style="float:left" @click="insertEvent(row)">添加物料</el-button>
          </template>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" v-if="isupdate" @click="createtree">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog
        title="添加备注"
        :visible.sync="remarkDialogVisible"
        width="420px"
        append-to-body
        :close-on-click-modal="false"
    >
      <el-input
          v-model="selectTable.remark"
          type="textarea"
          :rows="4"
          :maxlength="200"
          show-word-limit
          placeholder="请输入备注"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelRemark">取 消</el-button>
        <el-button type="primary" @click="submitWithRemark">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import Pagination from "../../component/Pagination/index.vue";

export default {
  components: {Pagination},
  data() {
    return {
      spxxList: {
        name: undefined,
        cs: undefined,
        spxx: [],
      },
      componentKey: 0,
      isupdate: false,
      spList: [],
      sdspList: [],
      total: 0,
      dialogTitle: '',
      queryParams: {
        pageNum: 1,
        pageSize: 10,
        pid: undefined,
        person: undefined,
        state: undefined,
        oname: undefined,
      },
      selectTable: {
        id: 0,
        remark: '',
        user: localStorage.getItem("user"),
        spxx: []
      },
      user: localStorage.getItem("user"),
      // 菜单列表
      dialogFormVisible: false,
      remarkDialogVisible: false,
      tableData: [],
      loading: false
    }
  },
  mounted() {
    this.getList();
    this.getDic("khlx");
    this.getproct()
  },

  methods: {
    handlePrnedd(row) {
      this.selectTable.spxx.forEach(item => {
        const match = this.spList.find(sp => sp.id === item.pid);
        const match1 = this.sdspList.find(sp => sp.pid === item.pid);
        if (match) {
          item.yz = match.yz;
          if(row && row.row.pid===match.id){
              this.selectTable.spxx[row.$index].cs = match.cs
          }
        }
        if (match1) {
          item.sd = match1.num;
        } else {
          item.sd = 0
        }
      });
    },
    formatproduct(str) {
      const found = this.spList.find(item => item.id == str)
      return found ? found.name : ''   // 没找到就返回空字符串或 '--'
    },
    insertEvent() {
      let record = {
        pid: undefined,
        num: undefined,
        yz: undefined,
        sd: undefined,
        cs:undefined
      }
      // 同时 push 到 test（保持同步）
      this.selectTable.spxx.push(record)

    },
    insertEvent1(row) {
      let sd=0;
      const match1 = this.sdspList.find(sp => sp.pid === row.id);
      if (match1) {
        sd = match1.num;
      }
      let record = {
        pid: row.id,
        num: undefined,
        yz: row.yz,
        sd: sd,
        cs:row.cs
      }
      // 同时 push 到 test（保持同步）
      this.selectTable.spxx.push(record)

    },
    delEvent(row) {
      console.log(row)
      // 删除前可以进行一些操作，比如提示确认
      this.$confirm('此操作将删除该行设备, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        console.log(row)
        // 确认删除时，splice方法会直接修改原数组
        this.selectTable.spxx.splice(row, 1);
        this.$message({
          type: 'success',
          message: '删除成功!提交后上传至服务器'
        });
      }).catch(() => {
        this.$message.info('操作已取消')
      });
    },
    getproct() {
      this.$request.postHttp({
        url: "/basic/getspAndSy",
        success: (data) => {
          this.spList = data.data

        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getsdproct() {

      this.$request.postHttp({
        url: "/basic/getMatchList",
        success: (data) => {
          this.sdspList = data.data
          this.handlePrnedd()
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    checkPrower(permission) {
      const qx = localStorage.getItem('qx');
      return qx && qx.includes(permission);
    },

    createtree() {
      if (!this.selectTable.spxx || this.selectTable.spxx.length === 0) {
        this.$message.warning('请至少添加一条物料');
        return;
      }
      // 2. 验证：pid 是否重复（记录索引）
      const pidMap = new Map();  // pid -> 第一次出现的索引
      const duplicateIndexes = [];

      this.selectTable.spxx.forEach((item, index) => {
        const rowNum = index + 1;  // 第几条物料（从1开始）

        if (pidMap.has(item.pid)) {
          duplicateIndexes.push({
            pid: item.pid,
            index1: pidMap.get(item.pid) + 1,  // 第一次出现的条数
            index2: rowNum                     // 重复出现的条数
          });
        } else {
          pidMap.set(item.pid, index);
        }
      });
      // 3. 验证：库存是否超限（记录索引）
      const overstockItems = this.selectTable.spxx
          .map((item, index) => ({
            ...item,
            rowNum: index + 1
          }))
          .filter(item => item.num > item.yz - item.sd);
      // pid 存在且数量为空、非数字或小于等于 0
      const invalidNumItems = this.selectTable.spxx
          .map((item, index) => ({...item, rowNum: index + 1}))
          .filter(item => item.pid && (
              item.num === null ||
              item.num === undefined ||
              item.num === '' ||
              !Number.isFinite(Number(item.num)) ||
              Number(item.num) <= 0
          ));
      if (invalidNumItems.length > 0) {
        const msg = invalidNumItems.map(item =>
            `第${item.rowNum}条物料 ${item.name || item.pid} 数量必须大于0`
        ).join('；');

        this.$message.warning(msg)
        return;
      }
// 4. 组合提示（优先提示重复，再提示库存）
      if (duplicateIndexes.length > 0) {
        const msg = duplicateIndexes.map(item =>
            `第${item.index1}条和第${item.index2}条物料重复`
        ).join('；');

        this.$message.warning(msg)
        return;
      }

      if (overstockItems.length > 0) {
        const msg = overstockItems.map(item =>
            `第${item.rowNum}条物料填报已超出库存数量`
        ).join('；');

        this.$message.warning(msg)
        return;
      }
      this.$confirm('是否添加备注？', '提示', {
        confirmButtonText: '是',
        cancelButtonText: '否',
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => {
        this.remarkDialogVisible = true
      }).catch(action => {
        if (action === 'cancel') {
          this.selectTable.remark = ''
          this.submitMatchInfo()
        }
      });
    },
    cancelRemark() {
      this.remarkDialogVisible = false
      this.selectTable.remark = ''
    },
    submitWithRemark() {
      if (!this.selectTable.remark || !this.selectTable.remark.trim()) {
        this.$message.warning('请输入备注')
        return
      }
      this.selectTable.remark = this.selectTable.remark.trim()
      this.remarkDialogVisible = false
      this.submitMatchInfo()
    },
    submitMatchInfo() {
      this.$request.postHttp({
        url: "/basic/saveMatchinfo",
        data: JSON.stringify(this.selectTable),
        success: (data) => {
          this.$message.success(data.msg)
          this.dialogFormVisible = false
          this.getList();
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    getDic(val) {
      this.$request.postHttp({
        url: "/system/getDic",
        params: {pname: val},
        success: (data) => {
          this.optionskhlx = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },

    cleardata() {
      this.queryParams = this.$options.data().queryParams
      this.getList()
    },
    createdata() {
      this.handleEdit({id: 0}, true)
    },
    getList() {
      this.loading = true;
      this.$request.postHttp({
        url: "/basic/getOrderMatchList",
        data: JSON.stringify(this.queryParams),
        success: (data) => {
          this.tableData = data.data.records
          this.total = data.data.total
          this.tableformat();
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
      this.loading = false;
    },
    tableformat() {
      const user = localStorage.getItem("user")
      this.tableData.forEach(item => {
        item.cz = item.pid === user
      })

    },
    deleterole(index, row) {
      this.$confirm('确认删除吗?', '提示', {
        cancelButtonText: '取消',
        confirmButtonText: '确定',
        type: 'warning'
      }).then(() => {
        this.upMatchState(row, '0')
      }).catch(() => {
        this.$message.info('操作已取消')
      });
    },

    handleEdit(row, state) {

      this.selectTable.id = row.id
      this.selectTable.remark = row.remark || ''
      this.remarkDialogVisible = false
      this.$request.getHttp({
        url: "/basic/getOrderMatch",
        params: {id: this.selectTable.id},
        success: (data) => {
          if (data.data == null) {
            this.selectTable.spxx = []
          } else {
            this.selectTable.spxx = data.data
          }
          this.isupdate = state
          this.dialogFormVisible = true
          if (row.id === 0) {
            this.dialogTitle = '新建配置订单'
          } else {
            this.dialogTitle = '修改配置订单'
          }
          this.componentKey += 1;
          this.getsdproct()
          this.getproct()
          if (state) {
            //加载产品参数列表
            this.getspxxList();
          }

        },
        error: (error) => {
          this.$message.error('打开失败！')

          // 执行失败时的操作
        },
      })
    },
    getspxxList(){
      if(!this.spxxList.name &&!this.spxxList.cs){
        return
      }
      this.$request.postHttp({
        url: "/basic/getspxxList",
        data: JSON.stringify(this.spxxList),
        success: (data) => {
          this.spxxList.spxx = data.data
        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    clearspxxdata(){
      this.spxxList=this.$options.data().spxxList
    },
    batchExport(row) {
      this.$request.postHttp({
        url: "/basic/MatchExport",
        params: {id: row.id},
        success: (data) => {
          if (data.code == 200) {
            this.$message.success('导出成功正在下载！')
            const link = document.createElement('a');
            link.href = data.msg;
            link.download = '装配单列表'; // 设置下载文件名
            link.style.display = 'none';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);


          } else {
            this.$message.warning(data.msg)
          }

        },
        error: (error) => {
          console.error("Error:", error);
          // 执行失败时的操作
        },
      })
    },
    upMatchState(row, state) {

      this.$request.postHttp({
        url: "/basic/upMatchState",
        data: JSON.stringify({id: row.id, state: state}),
        success: (data) => {
          if (data.code == 200) {
            this.$message.success(data.msg)
            this.getList();
          } else {
            this.$message.warning(data.msg)
          }

        },
        error: (error) => {
          this.$message.error('打开失败！')

          // 执行失败时的操作
        },
      })
    },
    formatstate(row) {
      if (row.state === '0') {
        return '作废'
      } else if (row.state === '1') {
        return '正在配单'
      } else if (row.state === '2') {
        return '订单已建立'
      } else if (row.state === '3') {
        return '库管正在出库'
      } else if (row.state === '4') {
        return '已完成'
      } else {
        return '未知'
      }
    }
  },
  computed: {
    selectedNames() {
      return this.selectedTags.map(t => t.name)
    }
  }
}
</script>
<style>
#rccx .el-date-editor.el-input {
  width: 100px !important;
}

selectupwidth el-select {
  width: 120px;
}
#dialogTitle .el-dialog__body{
  padding-bottom: 0px !important;
}
/*#roleListpage .el-pager li.active {
  color: white;
}*/
</style>
